export const CommonUtil = {
  // 組織の形式変更
  officeSorting: function (data) {
    let currentMaintenance = null;
    let currentOffice = null;
    let sortOffices = [];
    let officeInfo = [];

    // belongOfficeCodeでソートをかけている
    sortOffices = data.sort((a, b) => a.belongOfficeCode.localeCompare(b.belongOfficeCode));

    sortOffices.forEach(item => {
      
        // 第一階層のチェックと作成
      if (item.officeCode === "00" && item.branchCode === "00") {
        let newItem = { ...item, firstChild: [] };

        // dataは最終的な階層データを保持する配列
        officeInfo.push(newItem); 
        currentMaintenance = newItem;
        
        // 第二階層のチェックと作成
      } else if (item.branchCode === "00") {
        if (currentMaintenance) {
          let newItem = { ...item, secondChild: [] };
          currentMaintenance.firstChild.push(newItem);
          currentOffice = newItem;
        }

        // 第三階層のチェックと挿入
      } else { 
        if (currentOffice && item.maintenanceCode === currentMaintenance.maintenanceCode && item.officeCode === currentOffice.officeCode) {
          let newItem = { ...item };
          currentOffice.secondChild.push(newItem);
        }
      }
    });

    return officeInfo;
  },
}
